import React, { Component } from 'react';
import { Subscribe } from "unstated";
import StateContainer from "../../../state/StateContainer";

class FilterButton extends Component {
    state = { 
        isActive: false
    }

    /**
     * Sets opacity of filter depending on whether it is active.
     * @param currentFilter Array of currently active filters
     * @param filter Filter to be checked
     */
    setFilterOpacity(currentFilter,filter) {
        if(currentFilter.includes(filter)) {
            this.setState({isActive: true})
            return
        }
        this.setState({isActive: false})
    }

    render() { 
        return ( 
            <Subscribe to={[StateContainer]}>
                {(state2) => (

            <button
            className={this.props.buttonClass}
            style={{
                backgroundColor: state2.state.hotspotColors[this.props.buttonFilter].defaultColor,
                opacity: this.state.isActive? 1: 0.5
            }}
            
            onClick={async() => {
                await state2.setCurrentFilter(this.props.buttonFilter);
                this.setFilterOpacity(state2.state.currentFilter,this.props.buttonFilter)
              }}
              
            >
                {this.props.buttonFilter}
            </button>
                )}
            </Subscribe>
         );
    }
}
 
export default FilterButton;